import { CheckIcon, ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";

/** Compact clipboard button — swaps to a checkmark for ~1.2s after
 *  copy so the user gets visual confirmation without a toast. */
export function CopyButton({ value, ariaLabel }: { value: string; ariaLabel: string }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const t = window.setTimeout(() => setCopied(false), 1200);
    return () => window.clearTimeout(t);
  }, [copied]);
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      title={copied ? "Copied" : ariaLabel}
      onClick={() => {
        void navigator.clipboard.writeText(value).then(() => setCopied(true));
      }}
      className={`inline-flex items-center gap-1 rounded p-1 cursor-pointer transition-colors ${
        copied ? "text-emerald-600" : "text-text-tertiary hover:bg-bg-default hover:text-text-secondary"
      }`}
    >
      {copied ? <CheckIcon className="h-4 w-4" /> : <ClipboardDocumentIcon className="h-4 w-4" />}
    </button>
  );
}
